import { render } from "./Orders.vue?vue&type=template&id=1551bd99"
import script from "./Orders.vue?vue&type=script&lang=js"
export * from "./Orders.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/BinaryFlow/components/Account/Orders.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1551bd99"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1551bd99', __exports__)) {
    api.reload('1551bd99', __exports__)
  }
  
  module.hot.accept("./Orders.vue?vue&type=template&id=1551bd99", () => {
    api.rerender('1551bd99', render)
  })

}


export default __exports__